import StaticPlot from "../MathTools/StaticPlot"
import ShapePreview from "../MathTools/ShapePreview"

  function gcd(a, b) {
    a = Math.abs(a);
    b = Math.abs(b);
    while (b !== 0) {
      [a, b] = [b, a % b];
    }
    return a || 1;
  }

/* ----------------------------------------------------------
   2) getQuestionPool() - A bank of question generators
---------------------------------------------------------- */
function getQuestionPool(topic) {
  if (topic === "ratioPercent") {
    return [
      // 1) Ratio ➜ percent (existing but kept)
      {
        question: () => {
          const a = Math.floor(Math.random() * 5) + 1;   // 1‥5
          const b = Math.floor(Math.random() * 6) + 4;   // 4‥9
          const percent = ((a / b) * 100).toFixed(1);
          return {
            q: `Convert the ratio ${a}:${b} to a percent (1‑decimal).`,
            a: `${percent}%`,
            distract: [
              `${(percent * 0.5).toFixed(1)}%`,
              `${(percent * 1.3).toFixed(1)}%`
            ]
          };
        }
      },
  
      // 2) Unit‑rate distance ÷ time (existing but kept)
      {
        question: () => {
          const dist = (Math.floor(Math.random() * 8) + 2) * 50; // 100‥450 km
          const hrs  = Math.floor(Math.random() * 4) + 2;        // 2‥5 h
          const rate = (dist / hrs).toFixed(1);
          return {
            q: `A car travels ${dist} km in ${hrs} hours. What is the speed in km/h?`,
            a: rate,
            distract: [
              (rate - 10).toFixed(1),
              (parseFloat(rate) + 15).toFixed(1)
            ]
          };
        }
      },
  
      // 3) Percent ➜ simplified ratio a:b (new)
      {
        question: () => {
          const percentVal = Math.floor(Math.random() * 70) + 5;  // 5‥74 %
          const a = percentVal;
          const b = 100 - percentVal;
          const gcd = (x, y) => (y ? gcd(y, x % y) : x);
          const g  = gcd(a, b);
          return {
            q: `Write ${percentVal}% as a simplified ratio a:b where a represents the percent and b represents the remainder to make 100%.`,
            a: `${a / g}:${b / g}`,
            distract: [`${a}:${b}`, `${b / g}:${a / g}`]
          };
        }
      },
  
      // 4) Find the part given whole & percent (new)
      {
        question: () => {
          const whole = (Math.floor(Math.random() * 40) + 10) * 10; // 100‥500
          const percent = (Math.floor(Math.random() * 9) + 1) * 10; // 10,20…90
          const part = (whole * percent / 100).toFixed(1);
          return {
            q: `What is ${percent}% of ${whole}?`,
            a: part,
            distract: [
              (part * 0.8).toFixed(1),
              (part * 1.25).toFixed(1)
            ]
          };
        }
      },
  
      // 5) Percent increase / decrease (new)
      {
        question: () => {
          const original = (Math.floor(Math.random() * 20) + 5) * 5; // 25‥120
          const change   = Math.floor(original * (Math.random() * 0.5 + 0.1));
          const up       = Math.random() < 0.5; // increase or decrease
          const newer    = up ? original + change : original - change;
          const pct      = ((Math.abs(newer - original) / original) * 100).toFixed(1);
          return {
            q: `The value changes from ${original} to ${newer}. What is the percent ${up ? "increase" : "decrease"} (1‑decimal)?`,
            a: `${pct}%`,
            distract: [`${(pct * 1.5).toFixed(1)}%`, `${(pct * 0.5).toFixed(1)}%`]
          };
        }
      },
  
      // 6) Better buy? Compare two unit prices (new)
      {
        question: () => {
          const qtyA  = Math.floor(Math.random() * 5) + 2;  // 2‥6 items
          const costA = Math.floor(Math.random() * 8) + 4;  // $4‥11
          const qtyB  = qtyA + Math.floor(Math.random() * 4) + 1;
          const costB = costA + Math.floor(Math.random() * 6) + 2;
          const unitA = costA / qtyA;
          const unitB = costB / qtyB;
          const better = unitA < unitB ? "Option A" : "Option B";
          return {
            q: `Option A: ${qtyA} items for $${costA}.  Option B: ${qtyB} items for $${costB}. Which is the better buy?`,
            a: better,
            distract: [
              unitA < unitB ? "Option B" : "Option A",
              "Both the same"
            ]
          };
        }
      },
  
      // 7) Decimal ➜ percent (new)
      {
        question: () => {
          const dec = (Math.floor(Math.random() * 99) + 1) / 100; // 0.01‥0.99
          const pct = (dec * 100).toFixed(0);
          return {
            q: `Convert the decimal ${dec.toFixed(2)} to a percent.`,
            a: `${pct}%`,
            distract: [`${parseInt(pct) + 10}%`, `${pct - 5}%`]
          };
        }
      },
  
      // 8) Simplify a ratio (new)
      {
        question: () => {
          const k = Math.floor(Math.random() * 4) + 2; // common factor 2‥5
          const a = k * (Math.floor(Math.random() * 5) + 2); // 4k‥?k
          const b = k * (Math.floor(Math.random() * 5) + 3); // 6k‥?k
          return {
            q: `Simplify the ratio ${a}:${b}.`,
            a: `${a / k}:${b / k}`,
            distract: [`${a}:${b / k}`, `${a / k}:${b}`]
          };
        }
      }
    ];
  }
  // Enriched question pool for "fractionOps" topic in Grade8Math.js
// Replace the existing "fractionOps" section in getQuestionPool(topic)

else if (topic === "fractionOps") {
  return [
    // (1) Multi‑step: add two mixed numbers then multiply
    {
      question: () => {
        // mixed number A = w1 n1/d1
        const w1 = Math.floor(Math.random() * 3) + 1;    // 1..3
        const n1 = Math.floor(Math.random() * 5) + 1;    // 1..5
        const d1 = Math.floor(Math.random() * 6) + 2;    // 2..7
        // proper fraction B = n2/d2
        const n2 = Math.floor(Math.random() * 5) + 1;    // 1..5
        const d2 = Math.floor(Math.random() * 6) + 2;    // 2..7
        // random sign on mixed A and/or B
        const signA = Math.random() < 0.5 ? -1 : 1;
        const signB = Math.random() < 0.5 ? -1 : 1;

        // convert A to improper
        const impA = signA * (w1 * d1 + n1);
        // result improper numerator/denominator
        const resN = impA * (signB * n2);
        const resD = d1 * d2;

        return {
          q: `Multiply unsimplified: (${signA<0? "−": ""}${w1} ${n1}/${d1}) × (${signB<0? "−": ""}${n2}/${d2})`,
          a: `${resN}/${resD}`,
          distract: [
            `${resN + 1}/${resD}`,
            `${resN}/${resD + 1}`
          ]
        };
      }
    },

    // (2) Simplify after adding/subtracting three fractions
    {
      question: () => {
        const a = Math.floor(Math.random() * 8) + 1;
        const b = Math.floor(Math.random() * 8) + 2;
        const c = Math.floor(Math.random() * 8) + 1;
        const d = Math.floor(Math.random() * 8) + 2;
        const e = Math.floor(Math.random() * 8) + 1;
        const f = Math.floor(Math.random() * 8) + 2;

        // common denom
        const denom = b * d * f;
        // a/b + c/d - e/f => (a*d*f + c*b*f - e*b*d) / (b*d*f)
        const rawN = a * d * f + c * b * f - e * b * d;
        const gVal = gcd(rawN, denom);

        return {
          q: `Simplify: ${a}/${b} + ${c}/${d} - ${e}/${f}`,
          a: `${rawN / gVal}/${denom / gVal}`,
          distract: [
            `${(rawN + 1) / gVal}/${denom / gVal}`,
            `${rawN / gVal}/${(denom + 1) / gVal}`
          ]
        };
      }
    },

    // (3) Complex fraction: divide by a sum of two fractions
    {
      question: () => {
        const a = Math.floor(Math.random() * 6) + 1;
        const b = Math.floor(Math.random() * 6) + 2;
        const c = Math.floor(Math.random() * 6) + 1;
        const d = Math.floor(Math.random() * 6) + 2;
        const e = Math.floor(Math.random() * 6) + 1;
        const f = Math.floor(Math.random() * 6) + 2;

        // denominator = (c/d + e/f) = (c*f + e*d)/(d*f)
        const sumN = c * f + e * d;
        const sumD = d * f;

        // (a/b) ÷ (sumN/sumD) = (a * sumD) / (b * sumN)
        let num = a * sumD;
        let den = b * sumN;
        const gVal = gcd(num, den);

        return {
          q: `Simplify: (${a}/${b}) ÷ (${c}/${d} + ${e}/${f})`,
          a: `${num / gVal}/${den / gVal}`,
          distract: [
            `${(num + 1) / gVal}/${den / gVal}`,
            `${num / gVal}/${(den + 1) / gVal}`
          ]
        };
      }
    },

    // (4) Mixed operations: subtract then divide
    {
      question: () => {
        const w = Math.floor(Math.random() * 3) + 1;
        const n = Math.floor(Math.random() * 5) + 1;
        const d = Math.floor(Math.random() * 5) + 2;
        const n2 = Math.floor(Math.random() * 5) + 1;
        const d2 = Math.floor(Math.random() * 5) + 2;
        const n3 = Math.floor(Math.random() * 5) + 1;
        const d3 = Math.floor(Math.random() * 5) + 2;

        // (w n/d) - (n2/d2)
        const imp = w * d + n;
        const diffN = imp * d2 - n2 * d;
        const diffD = d * d2;

        // ÷ (n3/d3) => (diffN * d3)/(diffD * n3)
        let num = diffN * d3;
        let den = diffD * n3;
        const gVal = gcd(num, den);

        return {
          q: `Evaluate and simplify: (${w} ${n}/${d} - ${n2}/${d2}) ÷ ${n3}/${d3}`,
          a: `${num / gVal}/${den / gVal}`,
          distract: [
            `${(num + 1) / gVal}/${den / gVal}`,
            `${num / gVal}/${(den + 1) / gVal}`
          ]
        };
      }
    },

    // (5) Multi‑step word problem
    {
      question: () => {
        const cups = Math.floor(Math.random() * 3) + 2;
        const n = Math.floor(Math.random() * 5) + 1;
        const d = Math.floor(Math.random() * 5) + 2;
        const batches = Math.floor(Math.random() * 3) + 2;
        const extra = Math.floor(Math.random() * 3) + 1;

        // total used = (cups + n/d) * batches
        const imp = cups * d + n;
        const totalN = imp * batches;
        const totalD = d;

        // subtract extra whole cups
        const subN = extra * totalD;
        let remN = totalN - subN;
        const gVal = gcd(remN, totalD);

        return {
          q: `A recipe uses ${cups} ${n}/${d} cups per batch for ${batches} batches. If you use ${extra} extra full cups, how much remains (simplified)?`,
          a: `${remN / gVal}/${totalD / gVal}`,
          distract: [
            `${(remN + 1) / gVal}/${totalD / gVal}`,
            `${remN / gVal}/${(totalD + 1) / gVal}`
          ]
        };
      }
    }
  ];
}

else if (topic === "linearRelations") {
  return [
    {
      question: () => {
        const m = Math.floor(Math.random() * 5) + 1;  // 1..5
        const b = Math.floor(Math.random() * 7) - 3;  // -3..3

        // two unique wrong answers
        const wrong1 = (b + 1) === b ? b - 1 : b + 1;
        const wrong2 =
          (b + 2) === b || wrong1 === (b + 2)
            ? b - 2
            : b + 2;

        // build the "+ 2" or "− 3" part
        let interceptText;
        if (b > 0) {
          interceptText = `+ ${b}`;
        } else if (b < 0) {
          interceptText = `- ${Math.abs(b)}`;
        } else {
          interceptText = ""; // if b===0, just "y = mx"
        }

        return {
          q: `In the rule y = ${m}x${interceptText ? ` ${interceptText}` : ""}, what is the y‑intercept?`,
          a: b,
          distract: [wrong1, wrong2]
        };
      }
    },
    {
      question: () => {
        const m = Math.floor(Math.random() * 5) + 1;  // 1..5
        const b = Math.floor(Math.random() * 7) - 3;  // -3..3

        // two wrong answers
        const wrong1 = (b + 1) === b ? b - 1 : b + 1;
        const wrong2 =
          (b + 2) === b || wrong1 === (b + 2)
            ? b - 2
            : b + 2;

        // format intercept
        let interceptText;
        if (b > 0) {
          interceptText = `+ ${b}`;
        } else if (b < 0) {
          interceptText = `- ${Math.abs(b)}`;
        } else {
          interceptText = "";
        }

        const p0 = { x: 0, y: b };
        const p1 = { x: 1, y: m + b };

        return {
          q: `In the rule y = ${m}x${interceptText ? ` ${interceptText}` : ""}, what is the y‑intercept?`,
          a: b,
          distract: [wrong1, wrong2],
          visual: (
            <StaticPlot
              widthCells={10}
              heightCells={10}
              cellSize={20}
              points={[p0, p1]}
            />
          )
        };
      }
    }
  ];
}

else if (topic === "surfaceVolume") {
  // Basic rectangular/cyl. volume, surface area
  return [
    {
      question: () => {
        // fixed dimensions for illustration
        const l = 2, w = 2, h = 5;
        const V = l * w * h;                   // 2 × 2 × 5 = 20
        return {
          q: `Rect prism ${l}×${w}×${h}: what's its volume?`,
          a: V,
          distract: [`${V + 2}`, `${V - 2}`],
          visual: (
            <ShapePreview
              shape={{ type: "prismPreview", length: l, width: w, height: h }}
            />
          )
        };
      }
    },
    {
      question: () => {
        // cylinder volume
        const r = Math.floor(Math.random() * 3) + 2; // 2..4
        const h = Math.floor(Math.random() * 4) + 3; // 3..6
        const approxVol = (3.14 * r * r * h).toFixed(1);
        return {
          q: `Cylinder with radius=${r}, height=${h}. Approx volume (π≈3.14)?`,
          a: approxVol,
          distract: [
            (approxVol * 0.8).toFixed(1),
            (approxVol * 1.3).toFixed(1)
          ]
        };
      }
    }
  ];
}

  else if (topic === "statistics") {
    return [
      // 1) Pick best measure for skew
      {
        question: () => {
          const skew = Math.random() < 0.5 ? "left‑skewed" : "right‑skewed";
          return {
            q: `A data set is ${skew}. Which measure of centre best represents the “middle”?`,
            a: skew === "left‑skewed" ? "median" : "mean",
            distract: ["mode", skew === "left‑skewed" ? "mean" : "median"]
          };
        }
      },
  
      // 2) Mean only
      {
        question: () => {
          const arr = Array.from({ length: 6 }, () =>
            Math.floor(Math.random() * 20) + 1
          );
          const sum = arr.reduce((s, v) => s + v, 0);
          const mean = (sum / arr.length).toFixed(1);
          return {
            q: `Data set: [${arr.join(", ")}]. Find the mean (1‑decimal).`,
            a: mean,
            distract: [
              (parseFloat(mean) + 1).toFixed(1),
              (parseFloat(mean) - 1).toFixed(1)
            ]
          };
        }
      },
  
      // 3) Median only (odd number of items)
      {
        question: () => {
          const arr = Array.from({ length: 7 }, () =>
            Math.floor(Math.random() * 20) + 1
          );
          const sorted = [...arr].sort((a, b) => a - b);
          const median = sorted[Math.floor(sorted.length / 2)];
          return {
            q: `Data set: [${arr.join(", ")}]. Find the median.`,
            a: String(median),
            distract: [String(median + 1), String(median - 1)]
          };
        }
      },
  
      // 4) Mode only (guaranteed to have one)
      {
        question: () => {
          // generate 6 random values, then duplicate one of them
          const base = Array.from({ length: 5 }, () =>
            Math.floor(Math.random() * 20) + 1
          );
          const modeVal = base[Math.floor(Math.random() * base.length)];
          const arr = [...base, modeVal];
          // shuffle
          for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[j]] = [arr[j], arr[i]];
          }
          return {
            q: `Data set: [${arr.join(", ")}]. Find the mode.`,
            a: String(modeVal),
            distract: [String(modeVal + 1), String(modeVal - 1)]
          };
        }
      },
  
      // 5) Combined mean, median & mode
      {
        question: () => {
          const arr = Array.from({ length: 5 }, () =>
            Math.floor(Math.random() * 20) + 1
          );
          // force a mode
          arr.push(arr[0]);
          const sorted = [...arr].sort((a, b) => a - b);
  
          // mean
          const sum = sorted.reduce((s, v) => s + v, 0);
          const mean = (sum / sorted.length).toFixed(1);
  
          // median (odd length = 6 → take average of middle two)
          let median;
          const mid = sorted.length / 2;
          median = ((sorted[mid - 1] + sorted[mid]) / 2).toFixed(1);
  
          // mode: count frequencies
          const freq = {};
          sorted.forEach((v) => (freq[v] = (freq[v] || 0) + 1));
          const maxFreq = Math.max(...Object.values(freq));
          const mode = Object.keys(freq)
            .filter((k) => freq[k] === maxFreq)
            .join(", ");
  
          const answer = `Mean =${mean}, Median =${median}, Mode =${mode}`;
          return {
            q: `Data set: [${arr.join(", ")}]. Find the mean, median, and mode.`,
            a: answer,
            distract: [
              // shift mean
              `Mean =${(parseFloat(mean) + 1).toFixed(1)}, Median =${median}, Mode =${mode}`,
              // shift median
              `Mean =${mean}, Median =${(parseFloat(median) + 1).toFixed(1)}, Mode =${mode}`
            ]
          };
        }
      }
    ];
  }
  else {
    // final summary fallback
    return [
      {
        question: () => {
        // (5/6) ÷ (3/4) = (5/6) × (4/3) = 20/18 = 10/9
        return {
        q: "Simplify: (5/6) ÷ (3/4)",
        a: "10/9",
        distract: ["20/18", "9/10"]
        };
      }
    }
    ]
  }
}

/* ----------------------------------------------------------
   3) generateQuizQuestion()
      - picks a question from a relevant pool
---------------------------------------------------------- */
export function generateQuizQuestion(forcedTopic) {
  const topics = forcedTopic
    ? [forcedTopic]
    : ["ratioPercent","fractionOps","linearRelations","surfaceVolume","statistics","summary"];
  const topic = topics[Math.floor(Math.random()*topics.length)];
  const pool  = getQuestionPool(topic);

  const item  = pool[Math.floor(Math.random()*pool.length)];
  const qObj  = item.question();
  const distract = qObj.distract || [];
  const options = [qObj.a, ...distract].sort(() => Math.random() - 0.5);

  return {
    question: qObj.q,
    correctAnswer: qObj.a,
    options,
    visual: qObj.visual
  };
}